import BaseDropdown from './dropdown';

class ReconSelectionDropdown extends BaseDropdown {
	constructor(props) {
		super(props);
		this.type = 'reconSelections';
		this.label = 'Edit ROI REC';
		this.identifierField = 'label';
		this.dropdownDiv = null;
		this.hasSearch = false;
		this.state = {
			opened: false,
			focusIndex: null,
			reconSelections: this.props.items,
			reconAction: this.props.someReconciled,
			showEditGuardrails: false,
			guardrailLowerBound: this.props.guardrailLowerBound,
			guardrailUpperBound: this.props.guardrailUpperBound,
		};
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.someReconciled !== this.props.someReconciled) {
			this.setState({
				reconAction: this.props.someReconciled,
				showEditGuardrails: false,
			});
		}
		if (!prevState.opened && this.state.opened) {
			this.setState({
				reconAction: this.props.someReconciled,
				showEditGuardrails: false,
				guardrailLowerBound: this.props.guardrailLowerBound,
				guardrailUpperBound: this.props.guardrailUpperBound,
			});
		}
	}

	update() {
		const {reconAction, guardrailLowerBound, guardrailUpperBound} = this.state;
		const guardrailTxt = reconAction ? `(with guardrails: ${guardrailLowerBound} ${guardrailUpperBound})` : '';
		this.AnalyticService.trackEvent(
			this.props.gaEvent.category,
			'Execute',
			`${this.props.gaEvent.label} - reconciled status to ${reconAction}` + guardrailTxt
		);

		this.props.updateReconSelectionParams(reconAction, guardrailLowerBound, guardrailUpperBound);
	}
}

export default ReconSelectionDropdown;
